import routerOptions0 from "/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}